import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const PieChartIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 24 24" strokeWidth="1.5" {...props}>
            <path
                d="M21.21 15.89A10 10 0 1 1 8 2.83"
                stroke="currentColor"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M22 12A10 10 0 0 0 12 2v10z"
                stroke="currentColor"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
};
